import { render, staticRenderFns } from "./manageMyOrder.vue?vue&type=template&id=716c9b7a&"
import script from "./manageMyOrder.vue?vue&type=script&lang=js&"
export * from "./manageMyOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports